import Sops from './Sops';
export default Sops;
